import { useRef } from 'react';
import type { PackingState } from '../domain/schema';
export class TripUndo {
  private states: PackingState[] = [];
  push(state: PackingState) { this.states.push(structuredClone(state)); if (this.states.length > 20) this.states.shift(); }
  pop() { return this.states.pop(); }
  get size() { return this.states.length; }
}
export function useTripUndo() { const history = useRef<TripUndo>(); history.current ??= new TripUndo(); return history.current; }
